import { Config } from './config.model';

export class ConfigSerialize {
  public static toConfig(config: Config): any {
    return {
      data: {
        working_year: config.workingYear,
        start_date: config.startDate?.toISOString(),
        end_date: config.endDate?.toISOString(),
      },
    };
  }
}
